const ROLE_COOKIE_NAME = 'mf_role'
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365
const BRAND_DOMAINS = ['mathflat.co.kr', 'mathflat.com', 'schoolflat.com']

/** 학생 웹 QR 페이지가 읽을 수 있도록 브랜드 상위 도메인에 쓴다. localhost·IP·미리보기 도메인은 호스트 전용 쿠키가 된다 */
export const getRoleCookieDomain = (hostname: string) => {
  const host = hostname.toLowerCase()
  const domain = BRAND_DOMAINS.find((item) => host === item || host.endsWith(`.${item}`))
  return domain ? `.${domain}` : undefined
}

export const buildTeacherRoleCookie = ({
  hostname,
  protocol,
}: Pick<Location, 'hostname' | 'protocol'>) => {
  const domain = getRoleCookieDomain(hostname)
  return [
    `${ROLE_COOKIE_NAME}=teacher`,
    domain && `Domain=${domain}`,
    'Path=/',
    `Max-Age=${ONE_YEAR_SECONDS}`,
    'SameSite=Lax',
    protocol === 'https:' && 'Secure',
  ]
    .filter(Boolean)
    .join('; ')
}

// 로그인 성공과 로그인 상태 진입 때마다 다시 써서 Safari ITP 의 7일 상한을 갱신한다
export const writeTeacherRoleCookie = () => {
  try {
    document.cookie = buildTeacherRoleCookie(window.location)
  } catch {
    return
  }
}
